import {useEffect, useState} from "react";
import {deleteUser, getUsers, updateUser} from "../../../api/api";
import {CrudTable} from "../crud_tables/crud_tables";

export const UsersSection = () => {
    const [users, setUsers] = useState<any[]>([]);

    useEffect(() => { getUsers().then(setUsers).catch(console.error); }, []);

    const handleDelete = async (id: number) => {
        if (!window.confirm('Supprimer cet utilisateur ?')) return;
        await deleteUser(id);
        getUsers().then(setUsers);
    };

    const toggleRole = async (user: any) => {
        const newRole = user.role === 'ADMIN' ? 'USER' : 'ADMIN';
        await updateUser(user.id, newRole);
        getUsers().then(setUsers);
    };

    return (
        <div className="admin-card">
            <CrudTable cols={['id', 'email', 'role', 'createdAt']} rows={users} onDelete={handleDelete} onEdit={toggleRole} />
        </div>
    );
};
